import { PDFDocument } from 'pdf-lib';

//crear funcion para rellenar y firmar pdfs de forma global
const rellenarYDescargarCotizacion = async (datos) => {
    try {
        console.log('Iniciando la generación del PDF...');

        const urlPlantilla = '/tesifiveCotizacion.pdf';
        const plantillaBytes = await fetch(urlPlantilla).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(plantillaBytes);
        
        const form = pdfDoc.getForm();
        
        // Rellenamos todos los campos como antes
        form.getTextField('NombreCliente').setText(datos.cliente);
        form.getTextField('NumeroCliente').setText(datos.telefono);
        form.getTextField('TemaProyecto').setText(datos.tema);
        form.getTextField('NumCotizacion').setText(datos.cotizacionNum);
        form.getTextField('PrecioProyecto').setText(datos.precio);
        console.log('✅ Paso 4: Campos rellenados con datos.');

        // --- INICIO DEL CAMBIO ---
        // 5. En lugar de aplanar, bloqueamos todos los campos
        const fields = form.getFields();
        fields.forEach(field => {
            field.enableReadOnly(); // Marcamos el campo como "Solo Lectura"
        });
        console.log('✅ Paso 5: Todos los campos bloqueados (Solo Lectura).');
        // --- FIN DEL CAMBIO ---

        // 6. Guardar y descargar
        const pdfBytesFinal = await pdfDoc.save();
        console.log('✅ Paso 6: PDF final generado. Inicia la descarga.');
        
        const blob = new Blob([pdfBytesFinal], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Cotizacion-${datos.cliente.replace(/\s/g, '_')}.pdf`;
        link.click();

    } catch (error) {
        console.error("❌ Error detallado al generar el PDF:", error);
        alert("Hubo un error al generar la cotización. Revisa la consola.");
    }
};


export default rellenarYDescargarCotizacion;